import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import correct from "../../images/correct.svg";
import incorrect from "../../images/incorrect.svg";
import adjust from "../../images/adjust.svg";
// import equation from "../../images/equation.svg";
// import equationQ1 from "../../images/equationQ1.svg";

import styles from "./styles";
import "animate.css/animate.css";

const InfoModal = ({
  classes,
  infoText,
  closeModal,
  open,
  answeredCorrectly,
  question,
}) => {
  // let newPrice =
  //   parseFloat(question.old.price.replace(",", "")) *
  //   (question.new.cpi / question.old.cpi);
  return (
    <Modal open={open}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>

          <Typography
            className={classes.evalDesc}
            dangerouslySetInnerHTML={{ __html: infoText }}
          >
            {/* {question.detailText} */}
          </Typography>
          <Grid container justify="center">
            <Button
              className={classes.submitButton}
              onClick={() => closeModal()}
            >
              NEXT
            </Button>
          </Grid>
          {/* <Grid
            container
            style={{ textAlign: "center", justifyContent: "center" }}
          >
            <Typography
              className={classes.bottomDescription}
              dangerouslySetInnerHTML={{ __html: question.sourcesText }}
            >
            </Typography>
          </Grid> */}
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(InfoModal);
